export default "__VITE_ASSET__8c683ce1__"